import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchProduct, getBestSellerById, getScreensaver, postProduct } from '../services/customizerAPI';

export interface IGetBestSellerProductPayload {
  id: string;
  data?: {
    size: string | number;
    engraving?: string;
  };
}

export interface IGetScreensaverPayload {
  subpath?: string | null;
}

export const getProductDetail = createAsyncThunk(
  'GET_PRODUCT_DETAIL_ACTION_TYPES',
  async ({ url, type = 1 }: { url: string; type: number }) => {
    const response = await fetchProduct(url, type);
    return response?.data;
  }
);

export const createProduct = createAsyncThunk('CREATE_PRODUCT_ACTION_TYPES', async ({ data }: { data: any }) => {
  const response = await postProduct(data);
  return response?.data;
});

export const getBestSellerProduct = createAsyncThunk<any, IGetBestSellerProductPayload>(
  'lashbrook/getBestSellerProduct',
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await getBestSellerById(payload.id, payload.data);
      return fulfillWithValue(res.data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getScreensaverData = createAsyncThunk('GET_SCREENSAVER_DATA', async () => {
  const response = await getScreensaver();
  return response?.data;
});
